import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  Divider,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const viewerInstructions = [
  'Usa la rueda del mouse para hacer zoom y ajustar el tamaño de la estructura.',
  'Haz clic y arrastra con el botón izquierdo para girar la estructura en diferentes direcciones.',
  'Haz clic y arrastra con el botón derecho para mover la estructura a lo largo de la pantalla.',
  'Si el modelo tiene anotaciones, puedes hacer clic en ellas para ver información adicional.',
];

const Instructions = () => {
  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {/* Sección: Instrucciones del Viewer */}
      <Stack direction='column' spacing={2} mb={3}>
        <Typography variant='subtitle1' fontWeight="bold">
          Manipulación del Modelo 3D
        </Typography>
        <Typography variant='body2' textAlign='justify' color='text.secondary'>
          Para manipular la estructura anatómica ten en cuenta las siguientes instrucciones y
          realiza movimientos suaves:
        </Typography>
        <List dense>
          {viewerInstructions.map((instruction, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <CheckIcon color='success' fontSize='small' />
              </ListItemIcon>
              <ListItemText primary={instruction} primaryTypographyProps={{ variant: 'body2' }} />
            </ListItem>
          ))}
        </List>
      </Stack>

      <Divider sx={{ my: 3 }} />

      {/* Sección: Información sobre Pinecone */}
      <Stack direction='column' spacing={2}>
        <Typography variant='subtitle1' fontWeight="bold">
          Actualización de Vectores en Pinecone
        </Typography>

        <Box sx={{ backgroundColor: '#E7EDFE', p: 2, borderRadius: 1 }}>
          <Typography variant='body2' color='text.secondary'>
            <strong>Importante:</strong> Las actualizaciones a Pinecone se realizan de forma manual
            para optimizar costos y darte control sobre cuándo sincronizar los cambios.
          </Typography> 
        </Box>

        <Typography variant='body2' color='text.secondary' paragraph>
          Cuando editas el <strong>nombre</strong> o la <strong>descripción</strong> de una
          estructura anatómica, estos cambios se guardan en Sketchfab y en la base de datos, pero{' '}
          <strong>no se actualizan automáticamente en Pinecone</strong>.
        </Typography>

        <Stack direction='column' spacing={2}>
          <Typography variant='subtitle2' fontWeight={600} gutterBottom>
            ¿Cuándo actualizar en Pinecone?
          </Typography>
          <List dense>
            <ListItem sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <CheckIcon color='success' fontSize='small' />
              </ListItemIcon>
              <ListItemText
                primary='Cuando hayas terminado de editar y quieras que los cambios estén disponibles para las recomendaciones del asistente.'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
            <ListItem sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <CheckIcon color='success' fontSize='small' />
              </ListItemIcon>
              <ListItemText
                primary='Después de hacer varios cambios, puedes subir todo de una vez para optimizar costos.'
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          </List>
        </Stack>

        <Stack direction='column' spacing={2}>
          <Typography variant='subtitle2' fontWeight="bold" gutterBottom>
            ¿Cómo actualizar?
          </Typography>
          <Stack direction='column' spacing={0.5}>
            <Stack direction='row' spacing={1} alignItems='center'>
              <Typography variant='body2' color='text.secondary'>
                Usa el botón
              </Typography>
              <CloudUploadIcon color='primary' />
              <Typography variant='body2' color='text.secondary'>
                en la barra superior para sincronizar los cambios con Pinecone.
              </Typography>
            </Stack>
            <Typography display="flex" flexWrap="wrap" variant='body2' color='text.secondary'>
              Lo que se hará será subir el vector a Pinecone usando el nombre, descripción y anotaciones actuales de la estructura anatómica.
              En caso de que previamente exista un vector para la estructura anatómica, se eliminará el vector anterior y se subirá el nuevo.
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Instructions;
